import { IncomePaymentOneOffPaymentType } from "../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentOneOffPaymentType";
import { IncomePaymentSourceFrom } from "../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentSourceFrom";

export const incomePaymentOneOffSteppersMap = {
    incomePaymentOneOffDetail: "Income payment detail",
    incomePaymentOneOffReview: "Review",
    incomePaymentOneOffDocumentsAndDeclations: "Documents & declarations",
    incomePaymentOneOffConfirmation: "Confirmation",

};

export enum IncomeArrangementType {
    Capped,
    Flexi,
}

export const getString = (IncomePaymentOneOffPaymentType: IncomePaymentOneOffPaymentType): string => {
    return getMap().get(IncomePaymentOneOffPaymentType);
}

export const getSourceFromMap = (): Map<IncomePaymentSourceFrom, string> => {
    const map = new Map<IncomePaymentSourceFrom, string>();
    map.set(IncomePaymentSourceFrom.SpecifyAmount, "Specify amount");
    map.set(IncomePaymentSourceFrom.SpecifyAssetorCash, "Specify asset/cash");
    return map;
}

export const getPaymentTypeOptions = (): IncomePaymentOneOffPaymentType[] => {
    const options = [
        IncomePaymentOneOffPaymentType.AvailableCash,
        IncomePaymentOneOffPaymentType.AssetsAndAvailableCash,
    ];
    return options;
};

export const getMap = (): Map<IncomePaymentOneOffPaymentType, string> => {
    const map = new Map<IncomePaymentOneOffPaymentType, string>();
    map.set(IncomePaymentOneOffPaymentType.AvailableCash, "Available cash");
    map.set(IncomePaymentOneOffPaymentType.AssetsAndAvailableCash, "Assets and available cash");
    return map
};

export const getSourceFromString = (PensionPaymentSourceFrom: IncomePaymentSourceFrom): string => {
    return getSourceFromMap().get(PensionPaymentSourceFrom);
};

export const getSourceFromOptions = (): IncomePaymentSourceFrom[] => {
    const options = [IncomePaymentSourceFrom.SpecifyAmount, IncomePaymentSourceFrom.SpecifyAssetorCash];
    return options;
};

export const BankDetailsContent = {
    labels: {
        selectBankAccount: "Select bank account",
        splitAcrossTwoBankAccounts: "Split across two bank accounts",
        bankAccount1: "Bank account 1",
        bankAccount2: "Bank account 2",
        addBankAccount: "Add bank account",
        proportionOfIncome: "Proportion of income"
    },
    messages: {
        percentageOver100: "value can't exceed 100%",
        percentageUnder0: "At least 0%",
        totalProportionOfIncomeNot100: "Total proportion of income must be 100%",
    }
}

export const NewIncomePaymentContent = {
    successMessage: (firstname: string, lastname: string, subAccountId) => `We've received your instruction to take a one-off income payment for ${firstname} ${lastname} (${subAccountId})`
}